<template>
	<div class="index">
	<div class="pre">
		<div class="pre_right">
			<div class="gdl_r_d1">
				<div @click="selectType(1)" v-if="device !== 'mobile'" :class="'gdlrd1_d1' + (typeIndex == 1 ? ' gdlrd1_d1_select' : '')">综合</div>
				<div @click="selectType(2)" v-if="device !== 'mobile'" :class="'gdlrd1_d1' + (typeIndex == 2 ? ' gdlrd1_d1_select' : '')">销量 <img v-show="typeIndex == 2"
					 src="../../assets/imgs/6.png" /><img v-show="typeIndex != 2" src="../../assets/imgs/7.png" /></div>
				<div @click="selectType(3)" v-if="device !== 'mobile'" :class="'gdlrd1_d1' + (typeIndex == 3 ? ' gdlrd1_d1_select' : '')">价格 <img v-show="typeIndex == 3"
					 src="../../assets/imgs/6.png" /><img v-show="typeIndex != 3" src="../../assets/imgs/7.png" /></div>
				<div class="goodsType">
					<a :class="['type', goodtype==0 ? 'xuanz' : '']" @click="typeClick(0,-1)"> 全部</a>
					<a :class="['type', goodtype==index+1 ? 'xuanz' : '']" @click="typeClick(item.ID,index)" v-for="(item, index) in goodsType" :key="index">{{ item.Title }}</a>
				</div>
				<div class="gdlrd1_d2" v-if="device !== 'mobile'" >共{{ allCount }}件商品</div>
			</div>
			<div class="goodsList">
				<div class="good" v-for="(item,index) in goodsList" :key="index" @click="toDetail(item.id)">
					<img class="goodimg" :src="imgUrl + item.Pic" />
					<div class="goodname">{{ item.Title }}</div>
					<div class="pro_pic">
            			￥<span>{{ item.Price }}</span>
          			</div>
          			<a>
						<img @click.stop="AddCart(item.id)"  class="pro_gwcimg" src="../Home/img/gouWuChe.png" />
					</a>
				</div>
			</div>
			<div class="page">
				<el-pagination class="prerbot_d2_elp" background @current-change="handleCurrentChange"
				 :page-size="pageSize" :layout="device === 'mobile' ? 'prev, pager' : 'total, prev, pager, next, jumper'" :total="allCount">
				</el-pagination>
			</div>
		</div>
	</div>
	</div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config"
import { mapGetters ,mapMutations } from "vuex"
	export default {
		data() {
			return {
				typeIndex: 1,
				page: 0,
				pageSize: 12,
				radio: "",
				rxlist: [],
				imgUrl: "",
				allCount: "",
				typeId:"",
				goodsList: [],
				goodsType:[],
				goodtype:0,
				ProductSizeId:'',
				num:1,
				id:'',
			}
		},
		computed: {
            ...mapGetters(["seachKey","device","userId"])
		},
		watch: {
			seachKey(newval, olval) {
            this.tid = ""
			this.page = 0
			this.GetNcpProductList()
        },
		},
		created: function() {
			this.imgUrl = VUE_APP_IMG_URL
		},
		mounted: function() {
			this.GetNcpProductList()
			this.GetTypeList()
		},
		methods: {
			...mapMutations("goods", ["SET_SEACH_KEY"]),
			selectType(index) {
				if (this.typeIndex != index) {
					this.typeIndex = index
					this.page = 0
					this.GetNcpProductList()
				}
			},
			toDetail(id) {
				this.$router.push({
					path: '/ncpgoodsdetail',
					query: {
						id: id
					}
				});
			},
			handleCurrentChange(e) {
				this.page = e - 1
				window.scrollTo(0, 0)
				this.GetNcpProductList()

			},
			typeClick(e,index){
				this.typeId = e
				this.goodtype = index+1
				console.log(index,'indx');
				this.page = 0
				this.GetNcpProductList()
			},
			async GetTypeList(){
        		var res = await this.$post("GetProductTypeList");
        		console.log(res,'产品类型列表');
				this.goodsType = res.data.ResultData;
    		},
			GetNcpProductList() {
				var that = this;
				that.$post('GetNcpProductList', {
						"page": that.page,
						pageSize:that.pageSize,
						orderBy: that.typeIndex,
						TypeId:that.typeId,
						KeyWords: that.seachKey,
					})
					.then(function(res) {
						that.goodsList = res.data.ResultData
						that.allCount = res.data.RowCount
						// for (var i in that.goodsList) {
						// 	that.goodsList[i].Pic = that.goodsList[i].Pic.split(",")[0]
						// }
						that.goodsList.forEach((pro) => {
    					    pro.Title = that.truncate(pro.Title,10)
    					    console.log(pro.Intro);
    					});
						console.log(res,'GetNcpProductList');
					})
			},
			truncate(value, length) {
    		 if (!value || value.length <= length) {
    		   return value;
    		 }
    		 return value.slice(0, length) + "...";
    		},	
			async AddCart(id) {
				this.id=id
    		  if (this.userId == "") {
    		    this.$router.push("/login");
    		    this.$message.error("请先登录后查看");
    		    return;
    		  }
			  let res = await this.$post("productDeatil", {id: this.id});
			  console.log(res,'productDeatil');
    		  this.ProductSizeId=res.data.ResultData.SizeList[0].id;
    		  if(this.ProductSizeId==''){
    		    this.$message.error("商品维护中，暂不可加入购物车");
    		  }else{
    		    let res = await this.$post("AddCart", {
    		      ProductId: this.id,
    		      Count: this.num,
    		      ProductSizeId:this.ProductSizeId
    		    });
    		    console.log(res,'addcart');
    		    this.$store.commit('updatecarSize', res.data.RowCount)
    		    if (res.data.Success == "true") {
    		      this.$message({
    		        message: res.data.Msg,
    		        type: "success",
    		      });
    		    } else {
    		      this.$message.error(res.data.Msg);
    		    }
    		  }
    		},	
		}
	}
</script>

<style scoped>
.index {
  width: 100%;
  background-image: url("../Home/img/组17.png");
  background-size: cover;
  /* 调整背景图片的尺寸，以填充整个容器 */
  background-position: center;
}
.goodsType {
    display: inline-block;
    padding: 0px 40px;
    font-size: 1em;
    color: #666;
}
.type{
	
	padding:10px 40px;
}
.xuanz{
	border-bottom: 2px solid red;
	color: red;
}
.goodsList{
	display: flex;
  	flex-wrap: wrap;
	margin-top: 20px;
	justify-content: center;
}
.good{
	/* flex: 1; */
	background-color: white;
	margin: 10px;
	position: relative;
}
.goodimg{
	width: 250px;
	height: 250px;
	margin: 12px;
}
.goodname{
	text-align: center;
}
.txt{
	text-align: center;
	margin-top: 10px;
}
.page{
	width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 28px;
    margin-bottom: 28px;
}

.pro_pic{
  color: red;
  padding-left: 15px;
  float: left;
}
.pro_pic span{
  font-size: 1.5em;
}
.pro_gwcimg{
  height: 25px;
  width: 25px;
  padding-right: 15px;
  float: right;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>